<template>
    <div class="mx-auto">
        <v-progress-circular
            :color="!error ? 'primary' : 'error'"
            :indeterminate="!error"
            size="180"
            width="10"
            class="text-center"
        >
            <strong v-if="!error" class="px-5">
                {{ paymentComplete ? $t('booking') : $t('payment_confirmation') }}...
            </strong>
            <strong v-else class="px-5">{{ $t('error') }}</strong>
        </v-progress-circular>
    </div>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import {ConfirmationRedirectMixin} from '~src/mixins/confirmationRedirectMixin.src'
    import {EventBus} from '@/utils/event-bus'

    @Component({})
    export class PaymentCompletePage extends mixins(ConfirmationRedirectMixin) {
        error = false
        paymentComplete = false

        async mounted() {
            await this.$store.restored
            await this.load()
        }

        async load() {
            const {
                paymentMethodId,
                bookingKey,
                basketKey,
                paymentNumber,
                product,
                corporatePolicyViolationCodeId,
                dueToConfirmDate,
                modifyService,
                orderId,
                processId,
                agentRefNumber,
            } = this.$route.query
            let pspResponse = this.$route.query
            delete pspResponse.status
            delete pspResponse.paymentMethodId
            delete pspResponse.bookingKey
            delete pspResponse.basketKey
            delete pspResponse.product
            delete pspResponse.corporatePolicyViolationCodeId
            delete pspResponse.paymentNumber
            delete pspResponse.agentRefNumber
            pspResponse = new URLSearchParams(pspResponse).toString()
            try {
                const paymentCompleteRs = await persistentStore.paymentComplete({
                    paymentMethodId: parseInt(paymentMethodId, 10),
                    ...(bookingKey && {bookingKey}),
                    ...(basketKey && {basketKey}),
                    paymentNumber,
                    pspResponse,
                })
                if (paymentCompleteRs.result === 'Success') {
                    this.paymentComplete = true
                    if (modifyService) {
                        await this.modifyService(paymentMethodId, bookingKey, orderId, processId)
                        return
                    }
                    try {
                        const bookRs = await persistentStore.book({
                            ...(bookingKey && {bookingKey}),
                            ...(basketKey && {basketKey}),
                            ...(agentRefNumber && {agencyInfo: {agentRefNumber: agentRefNumber}}),
                            paymentMethodId,
                            corporatePolicyViolationCodeId,
                            ...(dueToConfirmDate && {dueToConfirmDate}),
                        })
                        if (!persistentStore.selectedOrderId && !authStore.person) {
                            await this.$router.push({
                                name: `${product}Confirmation`,
                                query: {
                                    orderId: bookRs[0].orderId,
                                    ...(bookingKey && {bookingKey}),
                                    ...(basketKey && {basketKey}),
                                },
                            })
                        } else {
                            await this.redirectAfterPayment(bookRs[0].orderId, `${product}Confirmation`, {
                                orderId: bookRs[0].orderId,
                            })
                            if (persistentStore.selectedOrderId) {
                                persistentStore.SET_SELECTED_ORDER_ID(null)
                                if (persistentStore.selectedDestination) {
                                    persistentStore.SET_SELECTED_DESTINATION(null)
                                }
                            } else if (authStore.isB2B) {
                                EventBus.$emit('RESET_BOOKING_DATA')
                            }
                        }
                    } catch (e) {
                        this.$toast.error(this.$t('error_message.unknown_booking_error'))
                        this.error = true
                    }
                } else {
                    this.$toast.error(this.$t('error_message.payment_complete_error'))
                    console.error(paymentCompleteRs)
                    this.error = true
                }
            } catch (e) {
                this.$toast.error(this.$t('error_message.payment_complete_error'))
                console.error(e)
                this.error = true
            }
        }

        async modifyService(paymentMethodId, bookingKey, orderId, processId) {
            try {
                await this.$api.modifyService.post({
                    bookingKey,
                    paymentMethodId,
                })
                if (this.$conf.public.reservationReport && processId) {
                    try {
                        await this.$api.orders.put(orderId, {
                            servicesInfo: [
                                {
                                    processId,
                                    serviceSentToSupplier: false,
                                },
                            ],
                        })
                    } catch (e) {
                        /* empty */
                    }
                }
                await this.$router.push({name: 'order-details', params: {id: orderId}})
            } catch (error) {
                this.$toast.error(this.$t(error.errors[0].message))
                this.error = true
            }
        }
    }

    export default PaymentCompletePage
</script>
